export enum VirtualMachineType {
    Standard_B4ms = "Standard_B4ms",
    Standard_B8ms = "Standard_B8ms",
    Standard_D4s_v4 = "Standard_D4s_v4",
    Standard_D8s_v4 = "Standard_D8s_v4",
    Standard_D16s_v4 = "Standard_D16s_v4",
    Standard_D32s_v4 = "Standard_D32s_v4",

    Standard_D4s_v5 = "Standard_D4s_v5",
    Standard_D8s_v5 = "Standard_D8s_v5",
    Standard_D16s_v5 = "Standard_D16s_v5",
    Standard_D32s_v5 = "Standard_D32s_v5",
    Standard_D48s_v5 = "Standard_D48s_v5",
    Standard_D64s_v5 = "Standard_D64s_v5",
    Standard_D96s_v5 = "Standard_D96s_v5",

    Standard_E4s_v4 = "Standard_E4s_v4",
    Standard_E8s_v4 = "Standard_E8s_v4",
    Standard_E16s_v4 = "Standard_E16s_v4",
    Standard_E20s_v4 = "Standard_E20s_v4",
    Standard_E32s_v4 = "Standard_E32s_v4",
    Standard_F8s_v2 = "Standard_F8s_v2",
    Standard_F16s_v2 = "Standard_F16s_v2",

    Standard_D4as_v6 = "Standard_D4as_v6",
    Standard_D8as_v6 = "Standard_D8as_v6",
    Standard_D16as_v6 = "Standard_D16as_v6",
    Standard_D32as_v6 = "Standard_D32as_v6",
    Standard_D48as_v6 = "Standard_D48as_v6",
    Standard_D64as_v6 = "Standard_D64as_v6",
    Standard_D96as_v6 = "Standard_D96as_v6",
}
